import React, { useEffect } from 'react';
import Header from '@/components/header';
import Settings from '@/components/Settings';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function PDFViewer() {

  useEffect(() => {

  }, []);

  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <Header />
      <Settings />
    </SafeAreaView>
  );
}